import React from 'react';

import './Contacts.css';
import {ReactComponent as VkIcon} from "../../images/icons/vk.svg";
import {ReactComponent as TelegramIcon} from "../../images/icons/telegram.svg";
import {ReactComponent as YandexMapsBigImage} from "../../images/yandex-maps-big.svg";
import {ReactComponent as ExternalIcon} from "../../images/icons/external.svg";
import {ReactComponent as TwoGisMapsBigImage} from "../../images/2gis-maps-big.svg";
import MapImage from '../../images/map.png';
import BlockForm from "../../components/BlockForm/BlockForm";
import Utils from "../../utils";


class ContactsPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        Utils.setPageTitle('Контакты')
    }

    render() {
        return <div className='contacts-page'>
            <div className='page'>
                <div className='block'>
                    <img src={MapImage} alt=''/>
                    <div className='info'>
                        <div className='title'>Контакты</div>
                        <div className='sub'>
                            <div className='title'>Адрес</div>
                            <div className='description'>Омск, пр-т Комарова 21 к2,помещение 2П</div>
                        </div>
                        <div className='sub'>
                            <div className='title'>Почта</div>
                            <a className='description button' href='mailto:estei@inbox.ru'>estei@inbox.ru</a>
                        </div>
                        <div className='sub'>
                            <div className='title'>Телефоны для записи на приём</div>
                            <a className='description button' href='tel:+79059225522'>+7 905 922 55 22</a>
                            <a className='description button' href='tel:+7(3812)956010'>+7 (3812) 95 60 10</a>
                        </div>
                        <div className='sub'>
                            <div className='title'>Режим работы</div>
                            <div className='time-work'>
                                <div className='block-1'>
                                    <div className='label-1'>
                                        ПН - ПТ
                                    </div>
                                    <div className='label-2'>
                                        с 9 до 19
                                    </div>
                                </div>
                                <div className='block-2'>
                                    <div className='label-1'>
                                        СБ
                                    </div>
                                    <div className='label-2'>
                                        с 9 до 14
                                    </div>
                                </div>
                                <div className='block-3'>
                                    <div className='label-1'>
                                        ВС
                                    </div>
                                    <div className='label-2'>
                                        Выходной
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='sub'>
                            <div className='title'>Другие способы связи</div>
                            <div className='social-media-container'>
                                {/*<a className='item button' href='#'>*/}
                                {/*    <WhatsappIcon/>*/}
                                {/*</a>*/}
                                <a className='item button' href='https://t.me/esteistom' target='_blank'>
                                    <TelegramIcon/>
                                </a>
                                <a className='item button' href='https://vk.com/estei'>
                                    <VkIcon/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='maps'>
                    <div className='card'>
                        <div className='top'>
                            <YandexMapsBigImage/>
                            <a href='https://yandex.com/maps/org/estei/1699146815/reviews/?ll=73.309824%2C54.983035&z=15'
                               target='_blank' className='button'>
                                Найти на карте
                                <ExternalIcon/>
                            </a>
                        </div>
                        <div className='label'>
                            Отзывы на картах Яндекса
                        </div>
                    </div>
                    <div className='card'>
                        <div className='top'>
                            <TwoGisMapsBigImage/>
                            <a href='https://2gis.ru/omsk/firm/70000001018401753/tab/reviews' target='_blank'
                               className='button'>
                                Найти на карте
                                <ExternalIcon/>
                            </a>
                        </div>
                        <div className='label'>
                            Отзывы на 2Гис
                        </div>
                    </div>
                </div>
                <BlockForm addSnackbar={this.props.addSnackbar}/>
            </div>
        </div>
    }
}


export default ContactsPage;
